import { connectWidget } from "../../widget-connector/WidgetConnector";
import useWidgetProxy from "hooks/useWidgetProxy";
import usePeriodsForReporting from "hooks/usePeriodsForReporting";
import { PERIODS_OPTIONS_TEMPLATE } from "hooks/usePeriodsWithTimeRangeExplorer";
import { PeriodsWidget as PeriodsWidgetComponent } from "components/widgets";

const PeriodsWidget = (props) => {
  const { widget } = props;
  const {
    proxy: optionsProxy,
    updateProxy: updateOptionsProxy,
    commit,
    rollback,
    isDirty,
  } = useWidgetProxy(widget, PERIODS_OPTIONS_TEMPLATE);

  const { periods, periodData, loading, getWindowOffsetStart } =
    usePeriodsForReporting({
      ...props,
      optionsProxy,
    });

  return (
    <PeriodsWidgetComponent
      {...props}
      widget={widget}
      optionsProxy={optionsProxy}
      updateOptionsProxy={updateOptionsProxy}
      commit={commit}
      rollback={rollback}
      isDirty={isDirty}
      periods={periods}
      data={periodData}
      loading={loading}
      getWindowOffsetStart={getWindowOffsetStart}
    />
  );
};

export default connectWidget(PeriodsWidget);
